import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1); // Go back in the browser history
  };

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }} className='my-4 d-flex flex-row align-items-center'>
        
        <ArrowLeft /> 
        <h4 className='p-0 m-0'>Back</h4>
        
    </div>
  );
}
